module.exports = __webpack_public_path__ + "static/media/halal.90d1c0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/halal.png
// module id = 1585
// module chunks = 0